import { PermissionsEnum } from "@/auth/interfaces";
import { a11yProps, sizeTab, useCheckPermissionsArray } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import PreRechazoPreagendamientoVenta from "../shared/componente/pre-rechazo-preagendamiento-venta/PreRechazoPreagendamientoVenta";
import PreRechazoAgendamientoVenta from "../shared/componente/pre-rechazo-agendamiento-venta/PreRechazoAgendamientoVenta";
// import PreRechazoAgendamientoVenta from "../shared/componente/pre-rechazo-agendamiento-venta/PreRechazoAgendamientoVenta";

export default function PreRechazadasVentaPage() {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_preagendamiento,
    PermissionsEnum.api_view_agendamiento,
  ]);
  const [valueTab, setValueTab] = useState(0);
  return (
    <SingleTableBoxScene
      title={"Gestión Ventas - PYL"}
      py={2}
      
      visibleReport={false}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Preagendamiento'} {...a11yProps(0)} />
          <Tab label={'Agendamiento'} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <PreRechazoPreagendamientoVenta />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <PreRechazoAgendamientoVenta />
      </CustomTabPanel>

    </SingleTableBoxScene >
  );

}